import { __rest, __assign, __spreadArray } from '../../node_modules/tslib/tslib.es6.js';
import { Button } from '@mui/material';
import React from 'react';
import brandclub_colors from '../../colors/brandclubColors.js';

var AppButton = function (_a) {
    var invertStyle = _a.invertStyle, children = _a.children, textColor = _a.textColor, backgroundColor = _a.backgroundColor, sx = _a.sx, rest = __rest(_a, ["invertStyle", "children", "textColor", "backgroundColor", "sx"]);
    return (React.createElement(Button, __assign({ disableRipple: true }, rest, { sx: __spreadArray([
            {
                height: 28,
                backgroundColor: backgroundColor || (invertStyle ? brandclub_colors.darkBlue : brandclub_colors.white),
                border: backgroundColor
                    ? 'none'
                    : "1px solid ".concat(invertStyle ? brandclub_colors.darkBlue : brandclub_colors.grayLight),
                borderRadius: 5,
                color: textColor || (invertStyle ? brandclub_colors.white : brandclub_colors.darkBlue),
                fontSize: '1.1rem',
                fontWeight: 500,
                fontFamily: 'Roboto',
                textTransform: 'none',
                '&:hover': {
                    backgroundColor: backgroundColor || (invertStyle ? brandclub_colors.darkBlue : brandclub_colors.blueWhite),
                    transition: 'background-color 0.25s ease',
                },
                '&.Mui-disabled': {
                    opacity: invertStyle ? 0.6 : 1,
                    color: invertStyle ? brandclub_colors.white : brandclub_colors.gray5,
                    transition: 'background-color 0.25s ease',
                },
            }
        ], (Array.isArray(sx) ? sx : [sx]), true) }), children));
};

export { AppButton };
//# sourceMappingURL=index.js.map
